import * as yup from 'yup';

export const PropertyAddressSchemaGenerator = () =>
  yup.object({
    streetAddress: yup.string().required().nullable(),
    unit: yup.string().nullable(),
    city: yup.string().required().nullable(),
    stateAbbreviation: yup.string().required().nullable(),
    zipCode: yup
      .string()
      .required()
      // eslint-disable-next-line
      .min(5, 'Enter ${min} digits')
      .nullable(),
  });

// TODO: doesn't work with yups documentation to make child not required, just duplicating
export const AddressSchemaGenerator = () =>
  yup.object({
    streetAddress: yup.string().notRequired().nullable(),
    unit: yup.string().nullable(),
    city: yup.string().notRequired().nullable(),
    stateAbbreviation: yup.string().notRequired().nullable(),
    zipCode: yup
      .string()
      .notRequired()
      // eslint-disable-next-line
      .min(5, 'Enter ${min} digits')
      .nullable(),
  });

const AddressSchema = PropertyAddressSchemaGenerator();
export type IAddressSchema = yup.InferType<typeof AddressSchema>;

export const createDefaultAddressData = (): IAddressSchema => ({
  streetAddress: null as unknown as string,
  unit: null,
  city: null as unknown as string,
  stateAbbreviation: null as unknown as string,
  zipCode: null as unknown as string,
});
